module.exports = __webpack_public_path__ + "static/media/cross_icon.e32219ef.svg";